<template>
  <section class="container-fluid my-4">
    <h4 class="my-4">Relatório de <strong>Livros</strong></h4>

    <form @submit.prevent="generateReport">
      <div class="row">
        <div class="form-group col-md-6">
          
          <div class="mb-3">
            <SearchableSelect
              v-model="team_id"
              :options="teams"
              item-text="name"
              item-value="id"
              label="Turma (Opcional)"
              placeholder="-- Todas as turmas --"
            />
          </div>

          <div class="mb-3">
            <SearchableSelect
              v-model="student_id"
              :options="studentsOptions"
              item-text="name"
              item-value="id"
              label="Aluno (Opcional)"
              placeholder="-- Todos os alunos --"
            />
          </div>

          <div class="mb-3">
            <label class="form-label">Tipo de Livro (Opcional)</label>
            <select v-model="book_type_id" class="form-control form-control-sm">
              <option value="">-- Todos os tipos --</option>
              <option v-for="bookType in bookTypes" :key="bookType.id" :value="bookType.id">
                {{ bookType.name }}
              </option>
            </select>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="start_date" class="form-label">Data Inicial (Opcional)</label>
              <input type="date" v-model="start_date" class="form-control form-control-sm" id="start_date">
            </div>
            <div class="col-md-6 mb-3">
              <label for="end_date" class="form-label">Data Final (Opcional)</label>
              <input type="date" v-model="end_date" class="form-control form-control-sm" id="end_date">
            </div>
          </div>

          <div v-if="!loading" class="form-group text-center my-2">
            <button type="submit" class="btn btn-success btn-sm mx-2 text-uppercase">
              Gerar Relatório
            </button>
            <button type="reset" class="btn btn-secondary btn-sm text-uppercase" @click="clearForm">
              Limpar
            </button>
          </div>

          <LoadingPage v-else />

        </div>
      </div>
    </form>

    <button class="btn btn-sm btn-secondary" @click="$router.go(-1)">
      VOLTAR
    </button>
  </section>
</template>

<script>
import api from "@/services";
import LoadingPage from "@/components/LoadingPage.vue";
import SearchableSelect from "@/components/SearchableSelect.vue";
import { handleBlobError } from "@/helpers";
import studentSearchMixin from "@/mixins/studentSearchMixin";

export default {
  name: "BooksReport",
  mixins: [studentSearchMixin],
  components: {
    LoadingPage,
    SearchableSelect,
  },
  data() {
    return {
      team_id: "",
      student_id: "",
      book_type_id: "",
      start_date: "",
      end_date: "",
      loading: false,
      teams: [],
      bookTypes: [],
      filteredStudents: [],
    };
  },
  watch: {
    team_id(newVal) {
      this.student_id = "";
      if (newVal) {
        this.getStudentsByTeam(newVal);
      } else {
        this.filteredStudents = [...this.students];
      }
    },
  },
  computed: {
    studentsOptions() {
      return this.team_id ? this.filteredStudents : this.students;
    },
  },
  methods: {
    async generateReport() {
      this.loading = true;

      const params = {};
      if (this.team_id) params.team_id = this.team_id;
      if (this.student_id) params.student_id = this.student_id;
      if (this.book_type_id) params.book_type_id = this.book_type_id;
      if (this.start_date) params.start_date = this.start_date;
      if (this.end_date) params.end_date = this.end_date;

      try {
        const response = await api.get("/exports/books-report", {
          params,
          responseType: "blob",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `relatorio_livros_${Date.now()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();

        Toast.fire("Sucesso", "Relatório gerado com sucesso!", "success");
      } catch (error) {
        handleBlobError(error, (message) => {
          Toast.fire("Erro", message, "error");
        });
      } finally {
        this.loading = false;
      }
    },
    clearForm() {
      this.team_id = "";
      this.student_id = "";
      this.book_type_id = "";
      this.start_date = "";
      this.end_date = "";
      this.filteredStudents = [...this.students];
    },
    async getTeams() {
      try {
        await api.get(`/teams?page=0&perPage=99999&sortBy=name&forPagination=1`).then((res) => {
          this.teams = res.data.data;
        });
      } catch (error) {
        console.error("Erro ao buscar turmas:", error);
      }
    },
    async getBookTypes() {
      try {
        const response = await api.get("/book-types?page=0&perPage=99999&sortBy=name");
        this.bookTypes = response.data.data;
      } catch (error) {
        console.error("Erro ao buscar tipos de livro:", error);
      }
    },
    async getStudentsByTeam(teamId) {
      try {
        const response = await api.get(`/teams/${teamId}/students`);
        this.filteredStudents = response.data.registrations.map(reg => reg.student).filter(s => s);
      } catch (error) {
        console.error("Erro ao buscar alunos da turma:", error);
        this.filteredStudents = [];
      }
    },
  },
  mounted() {
    this.getTeams();
    this.getBookTypes();
  },
};
</script>

<style scoped>
</style>
